import { getRegistrationStatus, getAssertion, getPFRegistrationStatus } from "../services"
import OmniAural from "omniaural"
import { Constants } from "../Constants"

const validateResponse = (response) => {
  return `${response.code}` === "1200"
}

const poll = ({ apiCall }) => {
  const maxTries = OmniAural.state.config.get_assertion_retry_limit.value() || 60
  const interval = (OmniAural.state.config.get_assertion_retry_interval.value() || 2) * 1000
  let totalTries = 0
  let timeoutId = null
  let isCanceled = false

  const executePoll = async (resolve, reject) => {
    if (isCanceled) {
      reject(new Error("Polling canceled"))
      return
    }

    const response = await apiCall()
    totalTries += 1
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    if (validateResponse(response)) {
      resolve(response)
    } else if (totalTries > maxTries) {
      let e = new Error("Max attempts exceeded. API call timed out")
      e.code = Constants.ERROR_CODES.POLLING_TIMEOUT
      reject(e)
    } else if (`${response.code}` !== Constants.ERROR_CODES.AWAITING_MOBILE_RESPONSE) {
      let e = new Error("Bad response code")
      e.code = response.code
      reject(e)
    } else {
      timeoutId = setTimeout(executePoll, interval, resolve, reject)
    }
  }

  return {
    promise: new Promise(executePoll),
    cancel: () => {
      isCanceled = true
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }
}

// Add Polling methods needed here.
export const PollingManager = {
  startAssertionPolling: (uid, params, onCompletion, onError) => {
    const { promise, cancel } = poll({
      apiCall: () => getAssertion(uid, params)
    })
    promise.then(onCompletion).catch(onError)
    return cancel
  },

  startRegistrationStatusPolling: (uid, onCompletion, onError) => {
    const { promise, cancel } = poll({
      apiCall: () => getRegistrationStatus(uid)
    })
    promise.then(onCompletion).catch(onError)
    return cancel
  },
  startPFRegistrationStatusPolling: (params, onCompletion, onError) => {
    const { promise, cancel } = poll({
      apiCall: () => getPFRegistrationStatus(params.uid, params.uuid)
    })
    promise.then(onCompletion).catch(onError)
    return cancel
  },

  startPFAssertionPolling: (params, onCompletion, onError) => {
    const { promise, cancel } = poll({
      apiCall: () => getAssertion("", params)
    })
    promise.then(onCompletion).catch(onError)
    return cancel
  }
}
